<template>
    <div class="row">
        <div class="col-md-12 p-10">
            <div class="card card-accent-primary" :class="{'bg-danger text-white': isInvalid}">

                <div class="card-header">
                    <div class="row">
                        <div class="col-md-8 pointer" @click="toggleSettings">
                            <h5>
                                Dokument (#{{ element.key }})
                            </h5>
                        </div>
                        <div class="col-md-4 text-right">
                            <button class="btn btn-sm btn-primary"
                                    :class="{ disabled: $parent.hasLowestSort(element) }"
                                    :disabled="$parent.hasLowestSort(element)"
                                    @click="$parent.moveElementUp(element)">
                                <i class="fas fa-arrow-up"></i>
                            </button>
                            <button class="btn btn-sm btn-primary mr-4"
                                    :class="{ disabled: $parent.hasHighestSort(element) }"
                                    :disabled="$parent.hasHighestSort(element)"
                                    @click="$parent.moveElementDown(element)">
                                <i class="fas fa-arrow-down"></i>
                            </button>
                            <button @click="$parent.removeElementByKey(element.key)" class="btn btn-danger btn-sm">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body" v-if="this.showSettings">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="textInput">Beschreibungstext</label>
                            <input type="text" id="textInput" class="form-control" placeholder="Dieser Text wird vor dem Feld angezeigt" v-model="element.text">
                        </div>
                        <div class="col-md-12 mt-2">
                            <label for="placeholderInput">Platzhalter-Text</label>
                            <input type="text" id="placeholderInput" class="form-control" placeholder="Dieser Text wird in dem Feld angezeigt." v-model="element.placeholder">
                        </div>
                        <div class="col-md-12">
                            <hr>
                            <strong>Validierung</strong>
                        </div>
                        <div class="col-md-4">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" :id="'validation-required-' + element.key" v-model="element.validation.required">
                                <label class="custom-control-label" :for="'validation-required-' + element.key">
                                    Pflichtfeld?
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BuilderFileElement",
        props: ['element'],
        data() {
            return {
                showSettings: true,
            }
        },
        computed: {
            isInvalid() {
                let validation = this.element.validation;
                let min = parseInt(validation.min);
                let max = parseInt(validation.max);

                return min > max || max < min;
            }
        },
        methods: {
            toggleSettings() {
                this.showSettings = !this.showSettings;
            }
        }
    }
</script>

<style scoped>

    label {
        font-style: italic;
    }
</style>
